import { render, staticRenderFns } from "./StudentsAutoComplete.vue?vue&type=template&id=74f7d6a8&"
import script from "./StudentsAutoComplete.vue?vue&type=script&lang=js&"
export * from "./StudentsAutoComplete.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports